module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img flex-b",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLinkDiv),
      expression: "isShowLinkDiv"
    }],
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("closeGoogleAuthentication.hint")))]), _vm._v(" "), _c('v-form', {
    ref: "closeAuthenticationForm",
    model: {
      value: (_vm.closeAuthenticationValid),
      callback: function($$v) {
        _vm.closeAuthenticationValid = $$v
      },
      expression: "closeAuthenticationValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "E-mail",
      "required": ""
    },
    model: {
      value: (_vm.closeAuthenticationForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.closeAuthenticationForm, "regEmail", $$v)
      },
      expression: "closeAuthenticationForm.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Secret Key",
      "required": ""
    },
    model: {
      value: (_vm.closeAuthenticationForm.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.closeAuthenticationForm, "authenticationSecret", $$v)
      },
      expression: "closeAuthenticationForm.authenticationSecret"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('header.passwordHint'),
      "rules": _vm.passWordRules,
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.passWord),
      callback: function($$v) {
        _vm.passWord = $$v
      },
      expression: "passWord"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary white--text",
      "disabled": !_vm.closeAuthenticationValid
    },
    on: {
      "click": _vm.closeAuthentication
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowLinkDiv),
      expression: "!isShowLinkDiv"
    }],
    staticClass: "mt-5 mb-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("activation.valid")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 fw-bold primary--text",
    attrs: {
      "round": "",
      "flat": "",
      "outline": ""
    },
    on: {
      "click": _vm.goHomePage
    }
  }, [_vm._v(_vm._s(_vm.$t("page404.homepageButton")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f477ca7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CloseGoogleAuthentication.vue
// module id = 426
// module chunks = 0